import React, { useState, useEffect } from 'react';
import { Offcanvas, OffcanvasBody } from 'reactstrap';
import './BoatOwnerDetailsView.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Import FontAwesomeIcon
import {
  faWallet,
  faCalendar,
  faMapMarkerAlt,
} from '@fortawesome/free-solid-svg-icons'; // Added calendar and location icons
import { format, parseISO } from 'date-fns';
import { getOrdersByBoatOwner } from '../../api/order/orderApi.js';
import vesseldefault from '../../assets/images/vesseldefault.jpg';

const BoatOwnerDetailsView = ({ isOpen, details, toggle }) => {
  const [pastOrders, setPastOrders] = useState(null);
  const [error, setError] = useState(null);

  const fetchPastOrders = async (ownerId) => {
    try {
      const response = await getOrdersByBoatOwner(ownerId);
      console.log('Past Orders Response22:', response);
      setPastOrders(response.data.data || []); // Assuming response.data.orders is the array of orders
    } catch (error) {
      console.error('Error fetching past orders:', error);
      setError('Failed to fetch past orders.');
    }
  };

  useEffect(() => {
    if (details?._id) {
      //console.log('Boat Owner Details222:', details._id);
      fetchPastOrders(details._id); // Fetch past orders
    }
  }, [details]);
  // Default data if details prop is not provided
  const defaultDetails = {
    name: 'Ruvin Wijesinghe',
    profileImage: 'https://via.placeholder.com/150',
    about:
      'Experience the ocean’s freshest Yellowfin Tuna, straight from the pristine waters of the Indian Ocean. Carefully caught by skilled fishermen using sustainable practices, this tuna is known for its rich flavor, texture, and versatility in cooking.',
    address: 'No 88 Main Street Mawella',
    email: 'ruvinwijesinghe@gmail.com',
    phone: '+94 717 182 2433',
    location: 'New Caledonia',
    company: [
      { role: 'Company', experience: '10 years' },
      { role: 'Company', experience: 'Owner' },
    ],
    qualifications: [
      'Vessel Safety Certification',
      'Environment Compliance Certificate',
    ],
    vessels: [
      {
        name: 'Vessel Name 01',
        methods: ['Fishing Methods 01', 'Fishing Methods 02'],
      },
      {
        name: 'Vessel Name Dummy 02',
        methods: [
          'Fishing Methods 01',
          'Fishing Methods 02',
          'Fishing Methods 03',
        ],
      },
    ],
    orders: [
      {
        item: 'Fresh Yellowfin Tuna Lorem',
        date: '17/09/2024',
        location: 'California',
        price: 'LKR 7200-LKR 7200',
        status: 'Pending',
        image:
          'https://nftcalendar.io/storage/uploads/2022/02/21/image-not-found_0221202211372462137974b6c1a.png',
      },
      {
        item: 'Fresh Yellowfin Tuna Lorem',
        date: '17/09/2024',
        location: 'California',
        price: 'LKR 7200-LKR 7200',
        status: 'Pending',
        image:
          'https://nftcalendar.io/storage/uploads/2022/02/21/image-not-found_0221202211372462137974b6c1a.png',
      },
      {
        item: 'Fresh Yellowfin Tuna Lorem',
        date: '17/09/2024',
        location: 'California',
        price: 'LKR 7200-LKR 7200',
        status: 'Pending',
        image:
          'https://nftcalendar.io/storage/uploads/2022/02/21/image-not-found_0221202211372462137974b6c1a.png',
      },
    ],
    pictures: [
      'https://nftcalendar.io/storage/uploads/2022/02/21/image-not-found_0221202211372462137974b6c1a.png',
      'https://nftcalendar.io/storage/uploads/2022/02/21/image-not-found_0221202211372462137974b6c1a.png',
      'https://nftcalendar.io/storage/uploads/2022/02/21/image-not-found_0221202211372462137974b6c1a.png',
      'https://nftcalendar.io/storage/uploads/2022/02/21/image-not-found_0221202211372462137974b6c1a.png',
    ],
    reviews: [
      {
        image:
          'https://t4.ftcdn.net/jpg/06/08/55/73/360_F_608557356_ELcD2pwQO9pduTRL30umabzgJoQn5fnd.jpg',
        reviewer: 'Bradley Lawlor',
        rating: 4.5,
        text: 'Experience the ocean’s freshest Yellowfin Tuna, straight from the pristine waters of the Indian Ocean. Carefully caught by skilled fishermen using sustainable practices.',
      },
    ],
    Categories: [
      'Category 01',
      'Category 02',
      'Category 03',
      'Category 04',
      'Category 05',
      'Category 06',
    ],
    FishingMethods: [], // Added to prevent undefined
  };

  // Map API data to the expected structure
  const mapApiData = (apiData) => {
    return {
      name: `${apiData.firstName} ${apiData.lastName}` || defaultDetails.name,
      profileImage: apiData.profileImage || defaultDetails.profileImage,
      about: apiData.AboutMe || defaultDetails.about,
      address: apiData.address || defaultDetails.address,
      email: apiData.email || defaultDetails.email,
      phone: apiData.contactNumber || defaultDetails.phone,
      FishingMethods: Array.isArray(apiData.FishingMethods)
        ? apiData.FishingMethods
        : [], // Ensure array
      location: apiData.address
        ? apiData.address.split(',')[1]?.trim() || 'Unknown'
        : defaultDetails.location,
      company: apiData.company || defaultDetails.company,
      qualifications: [
        ...(apiData.certificates || []),
        apiData.EnvironmentComplianceCertificate
          ? 'Environment Compliance Certificate'
          : '',
        apiData.VesselSafetyCertification ? 'Vessel Safety Certification' : '',
      ].filter(Boolean),
      vessels:
        (apiData.Vessels || []).map((vessel) => ({
          name: vessel,
          methods: Array.isArray(apiData.FishingMethods)
            ? apiData.FishingMethods
            : [], // Ensure array
        })) || defaultDetails.vessels,
      orders: apiData.orders || defaultDetails.orders,
      pictures: apiData.pictures || defaultDetails.pictures,
      reviews: apiData.reviews || defaultDetails.reviews,
      Categories: apiData.Categories || defaultDetails.Categories,
    };
  };

  console.log('Boat Owner details:', details);

  // Use mapped data if details is provided, otherwise use defaultDetails
  const data = details ? mapApiData(details) : defaultDetails;

  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      centered
      direction="end"
      className="boat-owner-details-view"
    >
      <OffcanvasBody>
        <div className="two-column-layout">
          <div className="left-column">
            <button
              className="close-btn2"
              onClick={toggle}
            >
              ×
            </button>
            <div className="profile-section">
              <img
                style={{ margin: '0px 18px' }}
                src={data.profileImage}
                onError={(e) => {
                  e.target.onerror = null; // Prevent infinite loop
                  e.target.src = vesseldefault;
                }}
                className="profile-image"
                alt="Owner"
              />
              <h4 class="mobile">
                <span style={{ color: 'black', marginBottom: '20px' }}>
                  {data.name}
                </span>
              </h4>
            </div>

            <span className="sub-title-owner-canva">About Me</span>
            <div className="about-section">
              <p>{data.about}</p>
            </div>
            <hr />
            <span className="sub-title-owner-canva">Contacts</span>
            <div className="contact-section">
              <p>
                <i className="fa fa-envelope"></i> {data.email}
              </p>
              <p>
                <i className="fa fa-phone"></i> {data.phone}
              </p>
              <p>
                <i className="fa fa-globe"></i> {data.address}
              </p>
            </div>
            <hr />
            <span className="sub-title-owner-canva">Qualifications</span>
            <div className="qualifications-section">
              {data.qualifications.length > 0 ? (
                data.qualifications.map((qual, index) => (
                  <p key={index}>{qual}</p>
                ))
              ) : (
                <p>No qualifications available</p>
              )}
            </div>
            <hr />
            <span className="sub-title-owner-canva">Past Orders</span>
            <div className="orders-section">
              {pastOrders ? (
                // pastOrders.map((order, index) => (
                <div
                  // key={index}
                  className="order-item"
                >
                  <div className="d-flex">
                    <img
                      src={pastOrders.image || 'boat'} // Fallback to boat image if order.image is missing
                      alt="Order"
                      className="order-image"
                    />
                    <div>
                      <p>
                        <strong>
                          {pastOrders.Product_Name || 'Unknown Item'}
                        </strong>
                      </p>
                      <p className="mb-0">
                        <FontAwesomeIcon
                          icon={faCalendar}
                          className="mr-1"
                          style={{ color: '#6c757d', marginRight: '10px' }} // Gray color
                        />

                        {pastOrders.Created_At
                          ? format(
                              parseISO(pastOrders.Created_At),
                              'dd/MM/yyyy'
                            )
                          : 'N/A'}
                        <FontAwesomeIcon
                          icon={faMapMarkerAlt}
                          className="mr-5"
                          style={{
                            color: '#6c757d',
                            marginRight: '10px',
                            marginLeft: '10px',
                          }} // Gray color
                        />
                        {pastOrders.Harbour || 'N/A'}
                      </p>
                    </div>
                  </div>
                  <div className="d-flex mt-4 ml-1">
                    <p
                      style={{ padding: '0px 20px 0px 0px' }}
                      className="mr-4"
                    >
                      <FontAwesomeIcon
                        icon={faWallet}
                        className="mr-1"
                        style={{
                          fontSize: '18px',
                          color: 'gray',
                          marginRight: '10px',
                        }} // Green color for wallet icon
                      />
                      LKR {pastOrders.Price_per_Kg || 'N/A'}
                    </p>
                    <span
                      style={{
                        margin: '0 10px',
                        display: 'inline-block',
                        width: '2px',
                        height: '26px',
                        backgroundColor: '#ccc',
                        verticalAlign: 'middle',
                      }}
                    />
                    <span
                      style={{ padding: '3px 25px' }}
                      className="status-button-warning"
                      size="sm"
                    >
                      {pastOrders.Status || 'Unknown'}
                    </span>
                  </div>
                </div>
              ) : (
                // ))
                <p>No orders available</p>
              )}
            </div>
          </div>
          <div className="right-column">
            <h4 class="web">
              <span style={{ color: 'black', marginBottom: '20px' }}>
                {data.name}
              </span>
            </h4>
            {/* <button className="download-profile-btn mt-3 mb-2">
              Download Profile
            </button> */}
            <hr />
            <span className="sub-title-owner-canva">Categories</span>
            <div className="categories">
              {data.Categories.map((category, index) => (
                <button
                  key={index}
                  className="category-btn"
                >
                  {category}
                </button>
              ))}
            </div>
            <hr />
            <span className="sub-title-owner-canva">Vessels</span>
            <div className="vessels-section">
              {data.vessels.length > 0 ? (
                data.vessels.map((vessel, index) => (
                  <div
                    key={index}
                    className="vessel-item"
                  >
                    <p>
                      Vessel Name: <strong>{vessel.name}</strong>
                    </p>
                  </div>
                ))
              ) : (
                <p>No vessels available</p>
              )}
            </div>
            <hr />
            <span className="sub-title-owner-canva">Fishing Methods</span>
            <div className="vessels-section">
              {data.FishingMethods.length > 0 ? (
                data.FishingMethods.map((FishingMethod, index) => (
                  <div
                    key={index}
                    className="vessel-item"
                  >
                    <p key={index}>{FishingMethod}</p>
                  </div>
                ))
              ) : (
                <p>No fishing methods available</p>
              )}
            </div>
            <hr />
            <div className="pictures-section">
              <span className="sub-title-owner-canva">Pictures</span>
              <div className="pictures-grid">
                {data.pictures.length > 0 ? (
                  data.pictures.map((pic, index) => (
                    <img
                      key={index}
                      src={pic}
                      alt="Boat"
                      className="picture"
                    />
                  ))
                ) : (
                  <p>No pictures available</p>
                )}
              </div>
            </div>
            <hr />
            <span className="sub-title-owner-canva">Reviews</span>
            <div className="reviews-section">
              {data.reviews.length > 0 ? (
                data.reviews.map((review, index) => (
                  <div
                    key={index}
                    className="review-item"
                  >
                    <div className="reviewer-info">
                      <img
                        src={review.image}
                        alt="Reviewer"
                        className="reviewer-image"
                      />
                      <div>
                        <p>
                          <strong>{review.reviewer}</strong>
                        </p>
                        <p>Rating: {review.rating} ★</p>
                      </div>
                    </div>
                    <p>{review.text}</p>
                  </div>
                ))
              ) : (
                <p>No reviews available</p>
              )}
            </div>
          </div>
        </div>
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default BoatOwnerDetailsView;
